window.addEventListener('DOMContentLoaded', () => {
  addParentElement()
  keepBrandAgentClearOfStickyBar()

  const accordionContainer1 = document.querySelector('[id$="__collection_list_Pr36qH"]');
  const accordionContainer2 = document.querySelector('[id$="__collection_list_bK4CY9"]');
  accordion(accordionContainer1, 'すべてのブランドを見る');
  accordion(accordionContainer2, 'すべてのキーワードを見る');
})

const keepBrandAgentClearOfStickyBar = () => {
  const styleId = 'sakura-brand-agent-position';

  const addPositionStyle = () => {
    const shadowRoot = document.querySelector('#ads-agent-host')?.shadowRoot;
    if (!shadowRoot) return false;
    if (shadowRoot.querySelector(`#${styleId}`)) return true;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      [data-testid="entrypoint"] {
        bottom: var(--sakura-brand-agent-bottom, 1.5rem) !important;
        margin-bottom: 0 !important;
      }
      /* [2026-10-01 ボス「あんまり邪魔にならないように」B案] 紺の丸いボタンだけを右下に。
         Clarity の文（「この商品を確認してください」等）と質問の吹き出しは出さない。押した後の会話は Clarity のまま。
         中の作りが変わると効かなくなり、Clarity の元の見た目に戻る（壊れはしない）。 */
      /* 端末がダークモードだと Clarity は --accent-dark（白）を使い、白い丸に黒い印になる（2026-10-01 本番で発見）。どちらも紺に白い印でそろえる。 */
      :host { --accent: #132b46 !important; --accent-dark: #132b46 !important; }
      [data-testid="entrypoint"] [role="button"] svg { color: #fff !important; }
      [data-testid="entrypoint"] {
        left: auto !important;
        right: 12px !important;
        transform: none !important;
        translate: none !important;
      }
      [data-testid="entrypoint"] > button,
      [data-testid="entrypoint"] [role="button"] > div:nth-child(2),
      [data-testid="entrypoint"] [role="button"] > div:first-child > div:nth-child(2) {
        display: none !important;
      }
      [data-testid="entrypoint"] [role="button"],
      [data-testid="entrypoint"] [role="button"] > div:first-child,
      [data-testid="entrypoint"] [role="button"] > div:first-child > div:first-child {
        width: 48px !important;
        height: 48px !important;
        min-width: 0 !important;
        padding: 0 !important;
      }
      [data-testid="entrypoint"] [role="button"] { box-shadow: 0 2px 10px rgba(19, 43, 70, 0.2) !important; }
      [data-testid="entrypoint"] [role="button"] > div:first-child { background: transparent !important; }
      [data-testid="entrypoint"] [role="button"] > div:first-child > div:first-child { box-shadow: none !important; }
      [data-testid="entrypoint"] svg { width: 22px !important; height: 22px !important; }
    `;
    shadowRoot.appendChild(style);
    return true;
  };

  if (addPositionStyle()) return;

  const observer = new MutationObserver(() => {
    if (addPositionStyle()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 15000);
}

window.addEventListener('load', () => {
  localizePasscodeForm();
  addAfterPasswordInfo();
});

const localizePasscodeForm = () => {
  const wrapper = document.querySelector('.lockAccess__wrapper');
  const input = wrapper?.querySelector('#passcode');
  const submitLabel = wrapper?.querySelector('#passcodebtn span');
  if (!wrapper || !input || !submitLabel) return;

  const instruction = input.closest('.Lock__passcodeInputWrapper')?.previousElementSibling;
  if (instruction) {
    instruction.textContent = 'パスワードを入力して商品をご購入ください';
  }

  input.placeholder = 'パスワードを入力';
  input.setAttribute('aria-label', 'パスワード');
  submitLabel.textContent = '確認する';

  const emptyError = wrapper.querySelector('.Lock__Error-empty');
  const wrongError = wrapper.querySelector('.Lock__Error-wrong');
  if (emptyError) emptyError.textContent = 'パスワードを入力してください。';
  if (wrongError) wrongError.textContent = 'パスワードが正しくありません。';
}

const addParentElement = () => {
  const child1 = document.querySelector('[id$="__collection_list_rKRpQ3"]');
  const child2 = document.querySelector('[id$="__collection_list_jRrH6T"]');
  const parent = document.createElement('div');

  if (child1 && child2) {
    parent.classList.add('p-topWrapper');
    parent.classList.add('page-width');
    child1.parentNode.insertBefore(parent, child1);
    parent.appendChild(child1);
    parent.appendChild(child2);
  }
}

const accordion = (element, text) => {
  if (!element) return;
  const content = element.querySelector('.section__content');
  if (!content) return;
  const child = content.children[0]
  if (content.clientHeight >= child.clientHeight) return;


  // ボタンのラッパー要素を作成
  const buttonWrapper = document.createElement('div');
  buttonWrapper.classList.add('accordion-button-wrapper');
  // ボタンを作成
  const button = document.createElement('button');
  button.classList.add('accordion-button');
  button.textContent = text;
  buttonWrapper.appendChild(button);
  // ボタンをコンテンツの後に挿入
  content.insertAdjacentElement('afterend', buttonWrapper);

  // ボタンのクリックイベントを設定
  button.addEventListener('click', () => {
    const isActive = button.classList.contains('active-accordion');
    // クリックされたボタンがアクティブでない場合のみ開く
    if (!isActive) {
      button.classList.add('active-accordion');
      content.classList.add('active-accordion');
      content.style.height = content.scrollHeight + 'px'; // コンテンツの高さを設定
      button.textContent = '閉じる';
    } else {
      button.classList.remove('active-accordion');
      content.classList.remove('active-accordion');
      content.style.height = '';
      button.textContent = text;
    }
  });
}

const addAfterPasswordInfo = () => {
  const wrapper = document.querySelector('.lockAccess__wrapper');
  if (wrapper) {
    const info = document.createElement('div');
    info.classList.add('lockAccess__info');
    info.innerHTML = `
      <div class="p-productInfo">
        <h2>パスワードをお持ちでない方はこちら</h2>
        <div class="p-productInfo__content">
          <ul>
            <li><a href="https://line.me/R/ti/p/@381ufmhm" target="_blank" rel="noopener">LINE公式アカウントでお問い合わせ</a></li>
          </ul>
          <p>※お問い合わせ時は、こちらの内容をご連絡ください。<br>お名前 / 受診歴の有無 / 商品名 / 個数</p>
        </div>
      </div>
    `;
    wrapper.appendChild(info);
  }
}

/*
  [2026-09-26 再構築] <read-more>: 長い紹介文を3行だけ見せ「続きを読む」で開く（sections/main-collection-banner.liquid）。
  文はHTMLに全部あり、CSS の高さ制限で隠しているだけ。3行に収まる幅（PCなど）ではボタンを消して全文を出す。
*/
class ReadMore extends HTMLElement {
  connectedCallback() {
    this.body = this.querySelector('.c-readMore__body');
    this.toggle = this.querySelector('.c-readMore__toggle');
    if (!this.body || !this.toggle) return;
    this.toggle.addEventListener('click', () => this.setOpen(!this.classList.contains('is-open')));
    this.fit();
    window.addEventListener('resize', () => this.fit(), { passive: true });
  }

  fit() {
    if (this.classList.contains('is-open')) return;
    this.classList.remove('is-short'); // 高さ制限を戻してから測る（画面を回したときも正しく判定する）
    const overflowing = this.body.scrollHeight - this.body.clientHeight > 2;
    this.classList.toggle('is-short', !overflowing);
  }

  setOpen(open) {
    this.classList.toggle('is-open', open);
    this.toggle.setAttribute('aria-expanded', String(open));
    this.toggle.textContent = open ? '閉じる' : '続きを読む';
    if (open) sakuraPublish('sakura_read_more_open', {});
  }
}
if (!customElements.get('read-more')) customElements.define('read-more', ReadMore);

/*
  [2026-09-26 再構築] 計測（送る側だけ）: 再構築で足した入口が押されたら Shopify.analytics.publish で知らせる。
  受け取るカスタムピクセル（GA4 などへ送る側）はまだ作っていない（ボスの承認待ち）。ピクセルが無い間は何も起きない。
  イベント名は sakura_ で始める。送るのはページの場所・押した札の文字・行き先の URL だけで、個人を特定する情報は入れない。
*/
const sakuraPublish = (name, data) => {
  try {
    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Shopify.analytics.publish(name, Object.assign({ page: location.pathname }, data));
    }
  } catch (error) {
    // 計測の失敗で買い物を止めない
  }
};

(() => {
  const text = (el) => (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60);
  const href = (el) => el.getAttribute('href') || '';
  const rules = [
    ['.p-homeIntro__word', 'sakura_popular_word_click', (el) => ({ place: 'home', word: text(el), to: href(el) })],
    ['.search__most-searched-keywords a', 'sakura_popular_word_click', (el) => ({ place: 'search_drawer', word: text(el), to: href(el) })],
    ['.p-homeIntro__quickLink', 'sakura_quick_link_click', (el) => ({ label: text(el.querySelector('.p-homeIntro__quickText') || el).split(' ')[0], to: href(el) })],
    ['a.sc-heroSlides__link', 'sakura_hero_slide_click', (el) => ({ kind: el.dataset.scSlideKind || '', slide: Array.from(el.closest('[data-sc-hero-track]')?.children || []).indexOf(el.closest('[data-sc-hero-slide]')) + 1, label: text(el), to: href(el) })],
    ['.p-homePerks__cell', 'sakura_home_perk_click', (el) => ({ perk: el.dataset.scPerk || '', state: el.dataset.scPoint5xState || 'default', member: el.closest('[data-sc-member]')?.dataset.scMember === 'true', to: href(el) })],
    ['.p-homeBrowse__row, .p-homeBrowse .c-brandTile', 'sakura_browse_tile_click', (el) => ({ group: el.closest('[data-browse-group]')?.dataset.browseGroup || '', collection: href(el) })],
    ['.p-homeBrowse__allLink', 'sakura_browse_all_click', (el) => ({ group: el.closest('[data-browse-group]')?.dataset.browseGroup || '', to: href(el) })],
    ['[data-sc-points-open]', 'sakura_points_open', (el) => ({ from: el.dataset.scPointsOpen || '', day: document.documentElement.classList.contains('is-sc-point5x-day') ? 'point5x' : '' })],
    ['[data-sc-points-catch]', 'sakura_points_catch_click', (el) => ({ from: el.dataset.scPointsCatch || '', to: href(el) })],
    ['[data-sc-members-cta]', 'sakura_members_click', (el) => ({ cta: el.dataset.scMembersCta || '', member: el.closest('[data-sc-member]')?.dataset.scMember === 'true' })],
    ['.mobile-sticky-bar__link', 'sakura_bottom_bar_click', (el) => ({ item: text(el.querySelector('.mobile-sticky-bar__text') || el) })],
    ['.c-directory__link, .c-directory__group .c-brandTile', 'sakura_directory_click', (el) => ({ group: el.closest('section')?.getAttribute('aria-labelledby') || '', collection: href(el) })],
    ['.c-directory__jumpLink', 'sakura_directory_jump_click', (el) => ({ to: href(el) })],
    ['.p-relatedCollections a', 'sakura_related_collection_click', (el) => ({ collection: href(el) })],
    ['.c-priceList a', 'sakura_price_list_click', (el) => ({ product: href(el) })],
    ['.c-trustRow a', 'sakura_trust_row_click', (el) => ({ to: href(el) })],
    ['.c-pdpBrand', 'sakura_pdp_brand_click', (el) => ({ collection: href(el) })],
    ['.c-pdpRating', 'sakura_pdp_rating_click', () => ({})],
    ['.p-picksShelf a[href*="/products/"]', 'sakura_brand_picks_click', (el) => ({ product: href(el) })],
    ['.p-relatedConcern__link', 'sakura_related_concern_click', (el) => ({ collection: href(el) })],
    ['.footer a[href]', 'sakura_footer_click', (el) => ({ group: el.closest('[data-sc-footer-group]')?.dataset.scFooterGroup || '', label: text(el) || el.getAttribute('aria-label') || '', to: href(el) })],
  ];
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      for (const [selector, name, data] of rules) {
        const el = target.closest(selector);
        if (el) {
          sakuraPublish(name, data(el));
          break;
        }
      }
    },
    { capture: true },
  );
})();

/* [2026-09-27 IA v2] #members へ移動した後、ブラウザの標準の移動(スクロール)に
   任せたうえで区画自体にフォーカスを移す（FLOW #1・7章）。区画は tabindex="-1"（sections/home-members.liquid）。
   区画のフォーカスの輪は CSS 側で outline:none にする（押せる物ではないため）。
   [2026-09-28] 同じページへの「/#members」（ヘッダーの5倍デーのキャッチ・フッター・5倍デーの知らせ）と、
   ほかのページから /#members で開いた時にも効かせる。 */
(() => {
  const focusMembers = () => {
    const membersSection = document.getElementById('members');
    if (membersSection) membersSection.focus({ preventScroll: true });
  };
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const link = target.closest('a[href$="#members"]');
    if (!link || link.pathname !== window.location.pathname) return;
    requestAnimationFrame(focusMembers);
  });
  if (window.location.hash === '#members') focusMembers();
})();

/* [2026-09-26 DESIGN.md] G1: 浮いた部品（レビュー・AIチャット）は、下へ100pxスクロールするまで隠す。
   隠す実際のCSSは assets/add.css 側（html:not(.sc-scrolled) #poingpong2-floating, html:not(.sc-scrolled) #ads-agent-host）。 */
(() => {
  const SCROLLED_CLASS = 'sc-scrolled';
  const THRESHOLD = 100;
  const applyScrolledClass = () => {
    // [2026-10-01] AIの相談（Brand Agent）は開くと body を position:fixed にし、scrollY が 0 に戻る。
    // その時に sc-scrolled が無い（外れる）と、下の CSS が #ads-agent-host ごと隠し、開いた相談の画面まで
    // 見えなくなる。スクロールだけ止まって画面が固まったように見えた（ボス iPhone で報告）。
    // 画面が固定されている間は必ず見せる側にする（テーマの引き出しは body を固定しないので、ほかに影響しない）
    if (getComputedStyle(document.body).position === 'fixed') {
      document.documentElement.classList.add(SCROLLED_CLASS);
      return;
    }
    document.documentElement.classList.toggle(SCROLLED_CLASS, window.scrollY >= THRESHOLD);
  };
  applyScrolledClass();
  window.addEventListener('scroll', applyScrolledClass, { passive: true });
  // 開く時はスクロールが起きないことがある（ページの上で開いた時）。body の固定そのものを見張る
  new MutationObserver(applyScrolledClass).observe(document.body, { attributes: true, attributeFilter: ['style', 'class'] });
})();

/* [2026-09-26 新設] D5: ブランドページの「まずはこの1本」（sections/brand-picks.liquid）。
   同じ section を ?sort_by=best-selling で取り直し、中身（在庫あり先頭3つ）が変わっていたら差し替える。
   失敗・3秒超は何もしない（今の表示をそのまま残す）。中身のブロックだけ差し替えるので、
   前後で3枚のグリッドの大きさは変わらずガタつきは出ない。 */
class BrandPicksShelf extends HTMLElement {
  connectedCallback() {
    const sectionId = this.dataset.section;
    const baseUrl = this.dataset.url;
    if (!sectionId || !baseUrl) return;
    const controller = new AbortController();
    this._abortController = controller;
    const timeoutId = setTimeout(() => controller.abort(), 3000);
    const url = `${baseUrl}?sort_by=best-selling&section_id=${sectionId}`;
    fetch(url, { signal: controller.signal })
      .then((response) => (response.ok ? response.text() : Promise.reject(new Error('response not ok'))))
      .then((text) => {
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const nextList = parsed.querySelector('[data-picks-shelf-list]');
        const currentList = this.querySelector('[data-picks-shelf-list]');
        if (!nextList || !currentList) return;
        if (nextList.innerHTML !== currentList.innerHTML) {
          currentList.innerHTML = nextList.innerHTML;
        }
      })
      .catch(() => {})
      .finally(() => clearTimeout(timeoutId));
  }

  disconnectedCallback() {
    // [2026-09-27 phase4 E15] 要素がDOMから外れたら進行中のfetchをタイムアウト待ちにせず即中断する
    if (this._abortController) {
      this._abortController.abort();
      this._abortController = null;
    }
  }
}
if (!customElements.get('brand-picks-shelf')) customElements.define('brand-picks-shelf', BrandPicksShelf);

/* [2026-09-27 phase4 E14] Tab移動の停止点が下固定バー・浮きボタン・ヘッダーの裏に隠れないための
   scroll-padding。固定のpx決め打ちはせず、実際に描画されている要素を毎回測って
   --sc-scroll-pad-top / --sc-scroll-pad-bottom へ書き込む(消費側は assets/add.css の html セレクタ)。
   浮きボタン(#ads-agent-host・#poingpong2-floating)は非同期挿入・sc-scrolled到達で見え方が変わるため、
   起動時だけでなくリサイズ・スクロール・DOM追加・sticky-atc-bar--showの切り替えのたびに測り直す。 */
(() => {
  const PAD = 8;
  const root = document.documentElement;

  function occluderTop(el) {
    if (!el) return null;
    const cs = getComputedStyle(el);
    if (cs.visibility === 'hidden' || cs.display === 'none' || parseFloat(cs.opacity) === 0) return null;
    const r = el.getBoundingClientRect();
    if (r.width <= 0 || r.height <= 0) return null;
    // 画面内に縦方向で実際に重なっているものだけを占有とみなす。
    // (2026-09-27修正) 旧条件「下端が画面の一番下まで届く」は、下固定バーの上に
    // 隙間を空けて浮く#poingpong2-floating等のボタンを取りこぼしていた
    // (not-foundページの実測でobscuredCount=1として発覚・修正前は誤ってnullを返していた)。
    if (r.bottom <= 0 || r.top >= window.innerHeight) return null;
    return r.top;
  }

  function computeBottomPad() {
    const selectors = ['.mobile-sticky-bar', '.sticky-atc-bar.sticky-atc-bar--show', '#ads-agent-host', '#poingpong2-floating'];
    let minTop = null;
    selectors.forEach((sel) => {
      const t = occluderTop(document.querySelector(sel));
      if (t !== null && (minTop === null || t < minTop)) minTop = t;
    });
    const pad = minTop === null ? 0 : Math.max(0, Math.round(window.innerHeight - minTop + PAD));
    root.style.setProperty('--sc-scroll-pad-bottom', `${pad}px`);
  }

  function computeTopPad() {
    const headerH = parseFloat(getComputedStyle(root).getPropertyValue('--header-height')) || 0;
    root.style.setProperty('--sc-scroll-pad-top', `${headerH > 0 ? Math.round(headerH + PAD) : 0}px`);
  }

  function recompute() {
    computeTopPad();
    computeBottomPad();
  }

  let scheduled = false;
  function scheduleRecompute() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      recompute();
    });
  }

  recompute();
  window.addEventListener('load', recompute);
  window.addEventListener('resize', scheduleRecompute);
  window.addEventListener('scroll', scheduleRecompute, { passive: true });

  // Brand Agent・poing-pongの浮きボタンは非同期でbody直下に挿入される。追加を検知して測り直す
  new MutationObserver(scheduleRecompute).observe(document.body, { childList: true });

  // 商品ページのsticky-atc-bar--show切り替え(フッター到達で隠れる等)も測り直しのきっかけにする
  const atcBar = document.querySelector('.sticky-atc-bar');
  if (atcBar) {
    new MutationObserver(scheduleRecompute).observe(atcBar, { attributes: true, attributeFilter: ['class'] });
  }

  // --header-height の初回確定(FoxTheme.delayUntilInteraction経由)を取りこぼさないための1回だけの保険
  const firstInteractionEvents = ['keydown', 'mousemove', 'touchstart', 'wheel'];
  const onFirstInteraction = () => {
    scheduleRecompute();
    firstInteractionEvents.forEach((ev) => window.removeEventListener(ev, onFirstInteraction));
  };
  firstInteractionEvents.forEach((ev) => window.addEventListener(ev, onFirstInteraction, { passive: true }));
})();

/* ==== pdp-jump(2026-09-28) 商品ページの飛び先の列: 押すとその欄へ飛び、開け閉めの欄なら開く ==== */
document.addEventListener('click', (event) => {
  const link = event.target.closest('.sc-pdp-jump a[href^="#"]');
  if (!link) return;
  const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
  if (!target) return;
  event.preventDefault();
  // 全成分の欄(accordion-details)は open を入れると、テーマの動きのとおり開く
  if (target.tagName === 'DETAILS') target.open = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  // キーボードや読み上げで使う人のために、飛んだ先の見出しへフォーカスも移す
  const focusEl = target.tagName === 'DETAILS' ? target.querySelector('summary') : target.querySelector('h2, h3') || target;
  if (!focusEl.matches('a, button, summary, [tabindex]')) focusEl.setAttribute('tabindex', '-1');
  focusEl.focus({ preventScroll: true });
});
/* ==== pdp-jump ここまで ==== */

/* ==== pdp-clamp(2026-09-28) 商品詳細: 長い時だけ4行に畳み「続きを読む」を出す。文は最初から全部 HTML にある ==== */
const scClampInit = () => {
  document.querySelectorAll('[data-sc-clamp]').forEach((body) => {
    const toggle = body.parentElement.querySelector('.sc-clamp__toggle');
    if (!toggle || toggle.dataset.scReady) return;
    toggle.dataset.scReady = '1';
    // 畳んでみて、隠れるのが1行半以上ある時だけ畳んだままにする（1行だけのために「続きを読む」を押させない。JS が動かない時は全文が見える）
    body.classList.add('is-clamped');
    const lineHeight = parseFloat(getComputedStyle(body).lineHeight) || 28;
    if (body.scrollHeight - body.clientHeight < lineHeight * 1.5) {
      body.classList.remove('is-clamped');
      return;
    }
    toggle.hidden = false;
    const label = toggle.querySelector('.sc-clamp__label');
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      body.classList.toggle('is-open', open);
      if (label) label.textContent = open ? label.dataset.open : label.dataset.closed;
      if (!open) body.closest('.sc-detail')?.scrollIntoView({ block: 'nearest' });
    });
  });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scClampInit);
else scClampInit();
/* ==== pdp-clamp ここまで ==== */
